import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { Steps } from './steps';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
export var createStepsDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.steps', Steps.name);
    return {
        getCurrentStep: function () {
            var selectedStep = baseDriver.find('.step-container.selected');
            return { key: selectedStep.getDataAttr('key'), label: selectedStep.find('.step-label').getText() };
        },
        getSteps: function () {
            var steps = baseDriver.findAll('.step-container');
            return steps.map(function (step) {
                return { key: step.getDataAttr('key'), label: step.find('.step-label').getText() };
            });
        },
        goToStep: function (idx) {
            baseDriver.findAll(".step-inner-wrapper .step-idx").clickOn(idx);
        },
        stepDisabledAtIdx: function (idx) {
            return baseDriver.findAll('.step-container').get(idx).hasClass('disabled');
        }
    };
};
export var createSteps = function (props) {
    var elem = renderAndMountComponent(React.createElement(Steps, __assign({}, props)));
    return createStepsDriver(elem);
};
//# sourceMappingURL=steps.driver.js.map